<template>

  <Drawer initialWidth="2xl" @requestUnmount="hide" closeOnClickOutside>

    <template #header>
		<QuestionMarkCircleIcon class="w-8 h-8 mr-2"/>
    </template>

	<template #default="{ hide }">

      <div style="position: relative; width: 100%; height: 100%;">
			<iframe v-if="i18nUrl" :src="i18nUrl"
          class="w-full h-full border-0"
          style="position: absolute; top: -5rem; left: 0; width: 100%; height: calc(100% + 5rem);"
          frameborder="0"
          allowfullscreen
        />
      </div>

    </template>

  </Drawer>

</template>


<script lang="ts">
import Drawer from '@/components/ui/Drawer.v2.vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline';

export default {
	// Knowledge Base View (panel with iframe to show KB articles)
	name: "KBView",
	emits: ['requestClose'],

	props: {
		url: {
			type: [String, Object],
			required: true,
		}
	},

	components: {
		Drawer,
		QuestionMarkCircleIcon,
	},

	computed: {
		i18nUrl(): string {
			if(!this.url) {
				return '';
			}

			if (typeof this.url === 'string') {
				return this.url;
			}

			// Check strictly for plain objects (excluding arrays and null)
			if (typeof this.url === 'object' && !Array.isArray(this.url)) {
				let lang = 'en';

				if (typeof this.$i18n?.locale === 'string' && this.$i18n.locale) {
				lang = this.$i18n.locale.substring(0, 2);
				}

				const urlObj = this.url as Record<string, string>;

				// Try exact language match, fallback to 'en', or first available key
				return urlObj[lang] || urlObj['en'] || Object.values(urlObj)[0] || '';
			}

			return '';
		},
	},

	methods: {
		hide () {
			this.$emit('requestClose');
		},
	}
}
</script>
